import Vue from 'vue';
import Router from 'vue-router';

import Account from '@/pages/Account.vue';
import Accountcharge from '@/pages/Account_charge.vue';
import Accountcodepay from '@/pages/Account_codepay.vue';
import Accountresult from '@/pages/Account_result.vue';
import Accounttakeout from '@/pages/Account_takeout.vue';
import Identity from '@/pages/Identity.vue';
import Verify from '@/pages/Verify.vue';
import Verifyresult from '@/pages/Verify_result.vue';
import Reverifyresult from '@/pages/Reverify_result.vue';
import Evaluating from '@/pages/Evaluating.vue';
import Evaluatingresult from '@/pages/Evaluating_result.vue';
import Order from '@/pages/Order.vue';
import OrderDetail from '@/pages/Order_detail.vue';
import RichText from '@/pages/Rich_text.vue';
import Acctplus from '@/pages/Acctplus.vue';
import Acctplus_Identity from '@/pages/Acctplus_identity.vue';
import Acctplus_Info from '@/pages/Acctplus_info.vue';
import Acctplus_Bank from '@/pages/Acctplus_bank.vue';
import Acctplus_Takeout from '@/pages/Acctplus_takeout.vue';
import Acctplus_Charge from '@/pages/Acctplus_charge.vue';
import Acctplus_Profit_list from '@/pages/Acctplus_profit_list.vue';
import Acctpluscodepay from '@/pages/Acctplus_codepay.vue';
import Guide from '@/pages/Guide.vue';
import SupportBank from '@/pages/Support_bank.vue';
import Acctplus_detail from '@/pages/Acctplus_detail';

import Loading from '@/pages/Loading.vue';

// ---- test or base common vue component -----
import Base from '@/pages/Base.vue';
import Form from '@/pages/Form.vue';
import Canvas from '@/pages/Canvas.vue';
import Links from '@/pages/Links.vue';
// ---- test or base common vue component end -----

Vue.use(Router);

export default new Router({
	'routes': [{
		path: '/acctplus',
		name: 'Acctplus',
		component: Acctplus
	},{
		path: '/acctplus/info',
		name: 'Acctplus_Info',
		component: Acctplus_Info
	},{
		path: '/acctplus/charge',
		name: 'Acctplus_Charge',
		component: Acctplus_Charge
	},{
		path: '/acctplus/takeout',
		name: 'Acctplus_Takeout',
		component: Acctplus_Takeout
	},{
		path: '/acctplus/identity',
		name: 'Acctplus_Identity',
		component: Acctplus_Identity
	},{
		path: '/acctplus/bank',
		name: 'Acctplus_Bank',
		component: Acctplus_Bank
	},{
		path: '/acctplus/codepay',
		name: 'Acctpluscodepay',
		component: Acctpluscodepay
	},{
		path: '/acctplus/profit',
		name: 'AcctplusProfitList',
		component: Acctplus_Profit_list
	},{
		path: '/account',
		name: 'Account',
		component: Account
	},{
		path: '/account/charge',
		name: 'Accountcharge',
		component: Accountcharge
	},{
		path: '/account/takeout',
		name: 'Accounttakeout',
		component: Accounttakeout
	},{
		path: '/account/result',
		name: 'Accountresult',
		component: Accountresult
	},{
		path: '/account/codepay',
		name: 'Accountcodepay',
		component: Accountcodepay
	},{
		path: '/order/list',
		name: 'Order',
		component: Order
	},{
		path: '/order/detail',
		name: 'OrderDetail',
		component: OrderDetail
	},{
		path: '/identity',
		name: 'Identity',
		component: Identity
	},{
		path: '/verify',
		name: 'verify',
		component: Verify
	},{
		path: '/verify/result',
		name: 'verify_result',
		component: Verifyresult
	},{
		path: '/reverify/result',
		name: 'reverify_result',
		component: Reverifyresult
	},{
		path: '/evaluating',
		name: 'evaluating',
		component: Evaluating
	},{
		path: '/evaluating/result',
		name: 'evaluating_result',
		component: Evaluatingresult
	},{
		path: '/text',
		name: 'RichText',
		component: RichText
	},{
		path: '/guide',
		name: 'Guide',
		component: Guide
	},{
		path: '/support/bank',
		name: 'SupportBank',
		component: SupportBank
	},{
		path: '/acctplus/detail',
		name: 'acctplus_detail',
		component: Acctplus_detail
	},{
		path: '/',
		name: 'loading',
		component: Loading
	},{
		//======= common base start =======
		path: '/from',
		name: 'Form',
		component: Form
	},{
		path: '/base',
		name: 'Base',
		component: Base
	},{
		path: '/canvas',
		name: 'canvas',
		component: Canvas
	},{
		path: '/links',
		name: 'alllinks',
		component: Links
		//======= common base end =======
	}]
});



// WEBPACK FOOTER //
// ./src/router.js